import React from "react";

function ProjectProcess({ projectName }) {

 const projectData = {
  "workleisure": {
    client: "Workleisure",
    services: "Website Development",
    website: "https://workleisure.in",
    image : process.env.PUBLIC_URL + "/images/WL.png",
    desc: "Workleisure is a modern workspace platform designed to provide a seamless and professional digital experience for individuals and businesses seeking flexible work environments. The platform allows users to explore, compare, and connect with workspace solutions through a clean, intuitive interface. With a focus on simplicity and usability, it ensures that users can easily navigate and discover the right workspace that fits their needs. The website is built with a strong emphasis on performance, responsiveness, and user experience. Every element is carefully designed to deliver fast loading speeds, smooth navigation, and a visually appealing layout across all devices. The structured content and minimal design approach help highlight workspace offerings clearly, making the platform both functional and engaging for users. Beyond design and performance, Workleisure is developed with scalability and long-term growth in mind. The architecture allows for easy expansion of features and services as the business evolves. By combining modern design principles with robust development practices, the platform serves as a powerful digital presence that supports business growth and enhances user engagement.",
    specs: [
    "Frontend built with React Js. frameworks",
    "Backend built with Node Js. frameworks",
    "Optimized performance for fast loading speeds",
    "Clean and scalable architecture",
    "SEO optimized structure",
    "Cross-device compatibility",
  ],
  features: [
    "Workspace discovery",
    "Modern UI/UX",
    "Fast performance",
    "Responsive design",
  ],
  },

  "wellnivo": {
    client: "Wellnivo",
    services: "Website Development",
    website: "https://wellnivo.com/",
    image : process.env.PUBLIC_URL + "/images/Well.png",
    desc: "Wellnivo is a wellness-focused digital platform that connects users with curated health and wellness retreats, programs, and experiences across different locations. It is designed to help individuals discover personalized wellness journeys, including yoga retreats, Ayurvedic treatments, detox programs, and holistic healing experiences. The platform simplifies the process of exploring and selecting wellness services by bringing together trusted providers in one place. The website emphasizes a calm, user-friendly experience that aligns with the essence of wellness. With structured listings, location-based discovery, and detailed program information, users can easily browse and compare different wellness options. The platform focuses on both physical and mental well-being, offering experiences that promote relaxation, stress relief, and overall lifestyle improvement. Built with scalability and usability in mind, Wellnivo serves as a bridge between wellness seekers and service providers. It supports a wide range of wellness categories while maintaining a clean and organized interface, ensuring smooth navigation and accessibility across devices. By combining curated content with a seamless digital experience, the platform helps users take meaningful steps toward a healthier and more balanced lifestyle.",
  specs: [
    "Frontend built with React Js. frameworks",
    "Backend built with Node Js. frameworks",
    "Optimized performance for fast loading speeds",
    "Clean and scalable architecture",
    "SEO optimized structure",
    "Cross-device compatibility",
  ],
  features: [
    "Wellness Retrear Programs & Experiences",
    "Modern UI/UX",
    "Fast performance",
    "Responsive design",
  ],
  },

  "career-mitra": {
    client: "Career Mitra",
    services: "Website Development",
    website: "https://career-mitra.com/",
    image : process.env.PUBLIC_URL + "/images/career.png",
    desc: "Career Mitra is a career guidance and education consultancy platform designed to help students make informed decisions about their academic and professional futures. It provides expert counselling, admission assistance, and career planning support across multiple fields such as engineering, medical, management, law, and other professional courses. The platform focuses on guiding students at every stage of their journey, from choosing the right course to securing admission in suitable institutions. The platform emphasizes personalized guidance, helping students understand their interests, strengths, and career opportunities through structured counselling and support. By simplifying the complex process of college selection, applications, and documentation, Career Mitra ensures a smooth and stress-free experience for students and parents. Its services are designed to bridge the gap between students and educational institutions, making career planning more accessible and efficient. Built with a focus on clarity and usability, Career Mitra’s digital presence is structured to provide easy navigation, organized information, and reliable support. With the integration of digital tools and expert consultation, the platform continues to evolve as a comprehensive solution for career development. It plays a crucial role in shaping students’ futures by offering the right guidance, resources, and opportunities in an increasingly competitive educational landscape.",
   specs: [
    "Frontend built with React Js. frameworks",
    "Backend built with Node Js. frameworks",
    "Optimized performance for fast loading speeds",
    "Clean and scalable architecture",
    "SEO optimized structure",
    "Cross-device compatibility",
  ],
  features: [
    "Career Counselling",
    "Modern UI/UX",
    "Fast performance",
    "Responsive design",
  ],
  },

  "winndo": {
    client: "Winndo",
    services: "E-Commerce Development",
    website: "https://www.winndo.com/",
    image : process.env.PUBLIC_URL + "/images/win.png",
    desc: "Winndo is a modern e-commerce platform designed to provide users with a seamless and efficient online shopping experience. The platform focuses on delivering a clean, intuitive interface that allows customers to easily browse products, explore categories, and make informed purchasing decisions. With a structured layout and user-friendly navigation, Winndo ensures that users can quickly find what they are looking for without unnecessary complexity. The website is built with a strong emphasis on performance, responsiveness, and usability. It offers smooth navigation, fast loading speeds, and a fully responsive design that works consistently across mobile, tablet, and desktop devices. Product listings are organized in a clear and visually appealing way, helping users compare options, view details, and complete purchases with ease. This enhances both user engagement and overall conversion rates. Beyond functionality, Winndo is developed with scalability and long-term growth in mind. The platform supports expansion of product categories, integration of additional features, and optimization for future business needs. By combining modern design principles with robust development practices, Winndo serves as a reliable and scalable digital storefront that helps businesses grow their online presence and reach a wider audience.",
  specs: [
    "Frontend built with React Js. frameworks",
    "Backend built with Node Js. frameworks",
    "Optimized performance for fast loading speeds",
    "Clean and scalable architecture",
    "SEO optimized structure",
    "Cross-device compatibility",
  ],
  features: [
    "E-Commerce",
    "Modern UI/UX",
    "Fast performance",
    "Responsive design",
  ],
  },

  "mobile-repairing-tools": {
    client: "Mobile Repairing Tools",
    services: "E-Commerce Development",
   website: "http://www.mobilerepairingtools.com/",
    image : process.env.PUBLIC_URL + "/images/mob.png",
    desc: "Mobile Repairing Tools is a specialized e-commerce platform designed to provide a wide range of tools, equipment, and accessories for mobile repair professionals and technicians. The platform offers everything from precision screwdriver kits and soldering stations to advanced repair machines and testing tools, making it a one-stop solution for both beginners and experienced technicians. Its structured product categories allow users to easily explore and find the right tools required for efficient mobile repair.\nThe website is built with a focus on usability, performance, and organized navigation, ensuring a smooth shopping experience. Products are clearly categorized into segments such as soldering tools, rework stations, testing equipment, and accessories, helping users quickly locate specific items. This streamlined approach improves efficiency for professionals who rely on quick access to the right tools for their daily work. \nDesigned for scalability and long-term growth, the platform supports a wide inventory of products and continuous expansion of categories. With its emphasis on accessibility, reliability, and structured design, Mobile Repairing Tools serves as a dependable digital marketplace that helps technicians and businesses source high-quality repair equipment efficiently and cost-effectively.",
  specs: [
  "Frontend built with modern responsive web technologies",
  "Optimized performance for fast loading and smooth navigation",
  "Structured product catalog system",
  "Secure checkout and data handling",
  "Cross-device compatibility (mobile, tablet, desktop)",
  "Scalable architecture for product expansion",
  "SEO-optimized structure for better visibility",
],
  },

  "hrfs": {
    client: "HRFS",
    services: "EHR Financial Services Website",
    website: "https://www.hrfs.co.in/",
    image : process.env.PUBLIC_URL + "/images/hrfs.png",
    desc: "HRFS (HR Financial Services) is a financial advisory platform focused on providing expert mortgage solutions tailored to individual needs. The platform helps users navigate complex financial decisions such as buying a home, remortgaging, or investing in property by offering clear guidance and personalized consultation. Its goal is to simplify the mortgage process and provide users with confidence in their financial journey. \nThe website is designed to deliver a clean and professional user experience, making it easy for users to explore different mortgage options such as first-time buyer loans, buy-to-let investments, and remortgage solutions. Structured content, intuitive navigation, and clear service breakdowns ensure that users can quickly understand their options and take the next step toward securing the right financial product. \nBuilt with trust and reliability in mind, HRFS emphasizes personalized support through experienced advisors who guide clients throughout the entire process. The platform combines modern digital design with financial expertise, helping users make informed decisions while ensuring scalability for future services and growth.",
  specs: [
  "Modern responsive frontend for seamless user experience",
  "Structured service-based architecture for financial offerings",
  "Optimized performance for fast loading and accessibility",
  "Secure handling of user inquiries and financial data",
  "Cross-device compatibility (mobile, tablet, desktop)",
  "Scalable design for future service expansion",
  "SEO-optimized structure for better discoverability",
],
features: [
  "Mortgage advisory services",
  "First-time buyer guidance",
  "Buy-to-let and investment support",
  "Remortgage consultation",
  "Personalized financial advice",
  "User-friendly service navigation",
  "Trust-focused and professional UI",
  "Lead generation and inquiry system",
],
  },

  "gen-ai-chatbot": {
    client: "Business Automation",
    services: "AI Development",
    website: "Private Tool",
    image : process.env.PUBLIC_URL + "/images/ai.png",
    desc: " The Gen AI Chatbot is an intelligent conversational solution designed to automate customer interactions and enhance user engagement across digital platforms. It enables businesses to handle queries in real-time, provide instant responses, and deliver consistent support without manual intervention. By leveraging advanced natural language processing, the chatbot understands user intent and responds in a human-like manner, improving overall communication efficiency. \nThe system is built to integrate seamlessly with websites, applications, and internal tools, making it adaptable for various business use cases such as customer support, lead generation, and information delivery. It is designed with scalability and performance in mind, ensuring it can handle multiple conversations simultaneously while maintaining speed and accuracy. The chatbot can also be customized based on business requirements, allowing tailored responses and workflows. \nBeyond automation, the Gen AI Chatbot helps businesses reduce operational costs, improve response times, and enhance customer satisfaction. Its ability to learn and improve over time ensures continuous optimization and better outcomes. By combining intelligent automation with user-friendly interaction, the solution serves as a powerful tool for modern businesses looking to streamline communication and improve efficiency.",
 specs: [
  "Frontend built with React.js for interactive chat interface",
  "Backend powered by Node.js for real-time communication",
  "Integration with AI APIs (LLM / NLP engines)",
  "Real-time message processing with low latency",
  "Scalable architecture to handle multiple users simultaneously",
  "Secure API handling and data processing",
  "Cross-platform compatibility (Web & Mobile)",
],

features: [
  "AI-powered conversational chatbot",
  "Automated customer support & query handling",
  "Context-aware responses using NLP",
  "Customizable workflows & responses",
  "Multi-user conversation handling",
  "Integration with websites and business tools",
  "Real-time interaction with fast response time",
],
  },

  "linkedin-automation": {
    client: "Lead Generation Tool",
    services: "AI Development",
    website: "Private Tool",
    image : process.env.PUBLIC_URL + "/images/link.jpeg",
    desc: "The LinkedIn Automation Tool is a smart lead generation solution designed to streamline outreach, connection building, and engagement on LinkedIn. It helps businesses and professionals automate repetitive networking tasks such as sending connection requests, personalized messages, and follow-ups, enabling them to scale their outreach efficiently without manual effort. By simplifying the process, the tool allows users to focus more on conversions and relationship building. \nThe platform is built with a focus on performance, accuracy, and user control. It includes intelligent filtering, targeted audience selection, and automated workflows that ensure messages reach the right prospects at the right time. With features like auto messaging, connection management, and campaign tracking, the tool provides a structured and efficient approach to LinkedIn growth and lead generation. \nBeyond automation, the system is designed to enhance productivity while maintaining a natural engagement flow. It helps users generate consistent leads, improve response rates, and reduce time spent on manual tasks. By combining automation with smart targeting, the tool serves as a powerful solution for businesses looking to scale their LinkedIn presence and generate high-quality leads.",
  specs: [
  "Frontend built with React.js for dashboard and user controls",
  "Backend powered by Node.js for automation workflows",
  "LinkedIn automation via browser/session-based scripting",
  "Advanced filtering and targeting logic",
  "Scalable system for handling multiple campaigns",
  "Secure data handling and session management",
  "Real-time activity tracking and status monitoring",
],
features: [
  "Automated connection requests",
  "Personalized message automation",
  "Auto follow-up sequences",
  "Lead filtering and targeting system",
  "Campaign management dashboard",
  "Connection and response tracking",
  "Time-saving automation workflows",
  "Scalable lead generation system",
],
  },

  "bounzy": {
    client: "In House",
    services: "Game Development",
    Status: "Completed",
    image : process.env.PUBLIC_URL + "/images/bounz.png",
    desc: "Bounzy is a hyper-casual mobile game inspired by fast-paced arcade mechanics, where players control a panda character navigating through rotating platforms while avoiding obstacles. The objective is simple yet highly engaging — guide the panda safely through gaps, dodge hazards, and reach the bottom to clear each level. Designed for quick play sessions, the game delivers an addictive experience that keeps users coming back. \nThe gameplay focuses on smooth controls, responsive physics, and visually appealing environments to ensure a seamless user experience. Each level introduces increasing difficulty with faster rotations, tighter gaps, and more complex obstacle patterns. The use of a playful panda character adds charm and personality, making the game more engaging and accessible to a wide audience. \nBuilt with performance optimization in mind, Bounzy delivers fluid gameplay across devices while maintaining high frame rates and low load times. The game is designed to maximize retention through simple mechanics, progressive challenges, and satisfying visual feedback. It serves as a strong example of how minimal design combined with engaging gameplay can create a compelling hyper-casual experience.",
  specs: [
  "Developed using Unity game engine",
  "Optimized for smooth performance across mobile devices",
  "Physics-based gameplay mechanics for realistic movement",
  "Lightweight assets for fast loading and minimal lag",
  "Level-based progression system",
  "Cross-platform compatibility (Android & iOS ready)",
  "Efficient memory and performance optimization",
],
features: [
  "Hyper-casual gameplay mechanics",
  "Panda character with engaging animations",
  "Rotating platform navigation system",
  "Obstacle avoidance challenges",
  "Progressive level difficulty",
  "Smooth and responsive controls",
  "Addictive and replayable gameplay",
  "Minimalistic and colorful UI",
],
  },

  "bar-simulator": {
    client: "In House",
    services: "Game Development",
    Status: "Under Development",
    image : process.env.PUBLIC_URL + "/images/barsim.png",
    desc: "Bar Simulator is an interactive simulation game that puts players in the role of a bartender managing a dynamic and fast-paced bar environment. The game allows users to prepare drinks, serve customers, and handle multiple tasks simultaneously, creating an engaging and realistic gameplay experience. Designed to replicate real-world bar operations, it challenges players to balance speed, accuracy, and customer satisfaction. \nThe gameplay focuses on interactive mechanics and decision-making, where players must follow recipes, manage time efficiently, and respond to increasing customer demands. As levels progress, the complexity increases with more drink variations, faster-paced orders, and higher expectations, making the experience both challenging and rewarding. The immersive environment and smooth controls enhance realism and keep players engaged. \nBuilt with performance and scalability in mind, Bar Simulator delivers a smooth and optimized experience across devices. The game is designed to be expandable, allowing the addition of new levels, features, and gameplay mechanics over time. By combining realistic simulation with engaging gameplay, it offers a compelling experience that appeals to both casual and simulation game audiences.",
  specs: [
  "Developed using Unity game engine",
  "Optimized for smooth gameplay and high performance",
  "Interactive simulation-based mechanics",
  "Efficient asset and memory management",
  "Level-based progression system",
  "Scalable architecture for adding new features and levels",
  "Cross-platform compatibility (Android & iOS ready)",
],
features: [
  "Realistic bar simulation gameplay",
  "Drink preparation and serving mechanics",
  "Time management challenges",
  "Progressive difficulty levels",
  "Interactive UI and smooth controls",
  "Customer satisfaction system",
  "Expandable gameplay features",
  "Engaging and immersive experience",
],
  },

  "evara-furniture-ar": {
    client: "Evara Furnishing",
    services: "AR  APP Development",
    website: "Deployed",
    image : process.env.PUBLIC_URL + "/images/furn.png",
    desc: " Evara AR is an augmented reality furniture application designed to transform the way users explore and purchase furniture. The app allows customers to visualize furniture directly in their real-world environment using their mobile device, helping them make confident buying decisions. By bridging the gap between online browsing and physical experience, it creates a more interactive and engaging shopping journey. \nThe application focuses on delivering a seamless and intuitive user experience, enabling users to place, scale, and rotate furniture models in real time. With accurate spatial mapping and realistic 3D rendering, users can understand how a product fits within their space before making a purchase. This reduces uncertainty and enhances customer satisfaction by providing a true-to-life preview of products. \nBuilt with scalability and performance in mind, Evara AR supports high-quality 3D assets while maintaining smooth performance across devices. The platform is designed to integrate with e-commerce systems, allowing businesses to showcase their products in a more immersive way. By combining AR technology with user-friendly design, the app helps brands increase engagement, reduce returns, and deliver a modern shopping experience.",
  specs: [
  "Developed using Unity with AR Foundation / ARKit / ARCore",
  "Real-time AR object placement and environment tracking",
  "High-quality 3D model rendering and optimization",
  "Accurate scaling and spatial mapping",
  "Optimized performance for mobile devices",
  "Cross-platform compatibility (Android & iOS)",
  "Integration-ready with e-commerce platforms",
],
features: [
  "Augmented reality furniture visualization",
  "Real-time object placement in user environment",
  "Scale and rotate furniture interactively",
  "High-quality 3D product previews",
  "User-friendly and intuitive interface",
  "Enhanced shopping decision experience",
  "Reduced product return uncertainty",
  "Immersive and modern UI/UX",
],
  },

  "warzone": {
    client: "Game Project",
    services: "Game Development",
    website: "FPS Game",
    image : process.env.PUBLIC_URL + "/images/warz.png",
    desc: "Warzone is a high-intensity first-person shooter (FPS) game designed to deliver fast-paced combat and immersive gameplay. Players engage in dynamic battle scenarios where precision, reflexes, and strategy play a crucial role. The game focuses on creating an adrenaline-driven experience with smooth shooting mechanics, responsive controls, and engaging level design. \nThe gameplay is built around real-time action, where players navigate environments, eliminate opponents, and complete objectives in increasingly challenging scenarios. With optimized controls and fluid movement, the game ensures a seamless combat experience across devices. Visual effects, weapon feedback, and level progression are carefully designed to enhance realism and keep players engaged. \nWarzone is developed with a strong emphasis on performance and scalability, ensuring smooth gameplay even during intense combat sequences. The architecture allows for future expansion, including new maps, weapons, and game modes. By combining engaging mechanics with optimized performance, the game delivers a competitive and immersive FPS experience suitable for a wide range of players.",
  specs: [
  "Developed using Unity game engine",
  "First-person shooting mechanics with real-time controls",
  "Optimized rendering for high-performance gameplay",
  "Efficient asset and memory management",
  "Smooth player movement and camera system",
  "Level-based and scalable game architecture",
  "Cross-platform compatibility (Android & PC ready)",
],
features: [
  "Fast-paced FPS combat gameplay",
  "Responsive shooting and aiming mechanics",
  "Immersive environments and level design",
  "Smooth controls and player movement",
  "Progressive difficulty and challenges",
  "Weapon-based interaction system",
  "Optimized performance for real-time gameplay",
  "Expandable maps and game modes",
],
  },
};

  const project = projectData[projectName];

  if (!project) return <h2>Project Not Found</h2>;

  return (
    <div className="project-process">

      <div className="row justify-content-between">
        <div className="col">
          <div className="process-step">
            <h4>Client:</h4>
            <span>{project.client}</span>
          </div>
        </div>

        <div className="col">
          <div className="process-step">
            <h4>Services:</h4>
            <span>{project.services}</span>
          </div>
        </div>

        <div className="col">
          <div className="process-step">
            <h4>Website:</h4>
            <span>{project.website}</span>
          </div>
        </div>
      </div>
        <div className="row">
                <div className="col-12">
                  <div className="process-banner">
                    <img
                      src={project.image}
                      alt="images"
                    />
                  </div>
                </div>
                </div>
      <div className="project-overview">
        <h3>Overview</h3>
        <p>{project.desc}</p>
      </div>

       {/* TECHNICAL SPECS */}
  <div style={{ marginBottom: "30px" }}>
    <h4>Technical Specifications:</h4>

    {project.specs?.map((item, index) => (
      <p key={index}>• {item}</p>
    ))}
  </div>

  {/* FEATURES */}
  <div className="project-features" style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
    {project.features?.map((item, index) => (
      <div key={index} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <span style={{
          width: "20px",
          height: "20px",
          background: "linear-gradient(to right, #fb1818, #b90707)",
          borderRadius: "50%",
          display: "inline-block"
        }}></span>
        <span>{item}</span>
      </div>
    ))}
  </div>

    </div>
  );
}

export default ProjectProcess;